export class FiltroLembrete {
  status?: number;
  busca?: string;
}
